(function () {
    "use strict";

    // @ngInject
    function GoogleTagManagerServiceCtor($window) {
        this.$window = $window;
        this.$window.dataLayer = this.$window.dataLayer || [];
    }

    Services.GoogleTagManagerService = Class(() => {

        return {
            constructor: GoogleTagManagerServiceCtor,

            trackEvent(event, attributes) {
                var tag = { event: event };
                this.pushEvent(Object.assign(tag, attributes));
            },

            pushEvent(attributes) {
                this.$window.dataLayer.push(attributes);
            },
        };
    });
}());

